// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/product/DesignbackgroundAboutUs.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 27/02/2025
 */


 .aboutUs_videoCompOuterBox__Yk52H{
    width: 100%;
    height: 400px;
    overflow: hidden;
    position: relative;
    z-index: 0;
 }
.aboutUs_videoComp__tcN\\+x{
    position: relative;
    width: 100vw;
    z-index: 1;
    /* height: 300px; */
}
.aboutUs_videoBackgroundBox__ZkZ7L{
    position: absolute;
    background-color: rgba(0, 0, 0, 0.508);
    color: #ffffff;
    z-index: 2;
    top: 200px;
    height: 100%;
    width: 100vw;
    padding: 50px 0px 50px 100px;
}
.aboutUs_videoBackgroundText__0B1dp{
    color: #ffffff;
    width: 50vw;
    
}
.aboutUs_titelUnderLine__JSrJD{
    height: 3px;
    width: 70px;
    border-radius: 3px;
    background-color:#077d92 ;
    /* margin: 20px 0px; */
}
.aboutUs_ceoMainOutercontainer__BFMqU{
    display: flex;
    flex-direction: row;

}
.aboutUs_ceoMsgcontainer__iV-jx{
    padding: 100px;
    width: 50vw;

}
.aboutUs_ceoMsgFirsttxt__Uw6CI{
    color:  #097ea8 ;
    letter-spacing: 2px;
    font-weight: 200;
}
.aboutUs_aboutHeadertxt__M1PN9{
    font-weight: 800;
    color: #1d1d1d;
}
.aboutUs_ceoMsgBodytxt__cpM1z{
    color: #1d1d1d;
    padding-top: 20px; 
}
.aboutUs_ceoAvaterContainer__02vqu{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 30px; 
}
.aboutUs_ceoMainContainerBg__1Fh3U{
    position: relative;
    height: 500px;
    width: 50vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.aboutUs_AboutBodyImage__ccSp2{
    margin-top: 15%;
    width: 500px;
}

.aboutUs_aboutBodyContantOuter__vk9Y5{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 100px;

}
.aboutUs_secondeContainerPaper__vzOmo{
    padding: 50px;
}
.aboutUs_contentPaper__lzwVy{
    margin: 40px;
    box-shadow: none;
}

.aboutUs_nameTag1__O7Uzr{
    font-size: 24px;
}
.aboutUs_nameTag2__LqcRn{
    font-size: 18px;
}

@media (max-width: 1200px) {
    
    .aboutUs_secondeContainerPaper__vzOmo{
        padding: 10px;
    }
    .aboutUs_AboutBodyImage__ccSp2{
        height: 300px;
        width: 300px;
    }
    .aboutUs_aboutBodyContantOuter__vk9Y5{
        padding: 10px 100px 10px 100px; 
    }
    .aboutUs_ceoMsgcontainer__iV-jx{
        padding: 30px 10px 30px 100px;
    
    }
    .aboutUs_ceoMainContainerBg__1Fh3U {
        height: 300px;
    }
    .aboutUs_aboutHeadertxt__M1PN9{
        font-size: 22px;
    }
    .aboutUs_ceoMsgBodytxt__cpM1z{
        font-size: small;
        padding-top: 0px;
    }
    .aboutUs_contentPaper__lzwVy{
        margin: 10px;
    }
    .aboutUs_videoBackgroundText__0B1dp{
        width: 70vw;
    }
}

@media (max-width: 717px) {
    
    .aboutUs_AboutBodyImage__ccSp2{
        height: 200px;
        width: 200px;
    }
    .aboutUs_aboutBodyContantOuter__vk9Y5{
        padding: 10px 30px 10px 30px; 
    }
    .aboutUs_ceoMsgcontainer__iV-jx{
        width: 70vw;
        padding: 20px 20px 20px 30px;
    
    }
    .aboutUs_ceoMainContainerBg__1Fh3U {
        height: 250px;
    }
    .aboutUs_aboutHeadertxt__M1PN9{
        font-size: 22px;
    }
   
    .aboutUs_contentPaper__lzwVy{
        margin: 10px;
    }
    .aboutUs_videoBackgroundText__0B1dp{
        width: 70vw;
        font-size: small;
    }
    .aboutUs_videoBackgroundBox__ZkZ7L{
        padding: 10px 0px 10px 30px;
    }
    .aboutUs_ceoMsgFirsttxt__Uw6CI{
        font-size: smaller;
    }
    .aboutUs_aboutAvatar__9qUc4{
        width: 48px;
        height: 48px;
        margin-right: 5px;
    
    }
    .aboutUs_nameTag1__O7Uzr{
        font-size: 18px;
    }
    .aboutUs_nameTag2__LqcRn{
        font-size: 12px;
    }
}

@media (max-width: 520px) {
    
    .aboutUs_videoCompOuterBox__Yk52H{

        height: 200px;
        
     }
     .aboutUs_videoBackgroundText__0B1dp{
        font-size: x-small;
        font-weight: 200;
     }
     .aboutUs_videoBackgroundBox__ZkZ7L{
        top: 50px;
        height: 100%;
        width: 100vw;
        padding: 20px 0px 20px 20px;
    }
   
    .aboutUs_ceoMainContainerBg__1Fh3U{
        width: 10px;
        height: 10px;
    }
    .aboutUs_ceoMsgcontainer__iV-jx{
        padding: 20px;
        width: 90vw;
    
    }

    .aboutUs_ceoMsgFirsttxt__Uw6CI{
        font-size: x-small;
    }
    .aboutUs_aboutHeadertxt__M1PN9{
        font-size: 18px;
    }
    .aboutUs_ceoMsgBodytxt__cpM1z{
        font-size: x-small;
    }
    .aboutUs_aboutAvatar__9qUc4{
        width: 32px;
        height: 32px;
    
    }
    .aboutUs_ceoAvaterContainer__02vqu{
        padding-top: 10px;
    }
    .aboutUs_nameTag1__O7Uzr{
        font-size: 11px !important;
    }
    .aboutUs_nameTag2__LqcRn{
        font-size: 8px !important;
    }
    .aboutUs_aboutBodyContantOuter__vk9Y5{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 20px;
    
    }
}


@media (max-width:1024px){
    
}
@media (max-width:770px){
    
}
@media (max-width:480px){
    
}`, "",{"version":3,"sources":["webpack://./src/pages/aboutUs.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;CAGD;IACG,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;CACb;AACD;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,WAAW;;AAEf;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;;AAEvB;AACA;IACI,cAAc;IACd,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,yDAA6E;AACjF;AACA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;;AAElB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,YAAY;IAChB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,6BAA6B;;IAEjC;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,YAAY;IAChB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,4BAA4B;;IAEhC;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;;IAErB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;QAEI,aAAa;;KAEhB;KACA;QACG,kBAAkB;QAClB,gBAAgB;KACnB;KACA;QACG,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;QACb,WAAW;;IAEf;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;;IAEhB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,aAAa;;IAEjB;AACJ;;;AAGA;;AAEA;AACA;;AAEA;AACA;;AAEA","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 27/02/2025\r\n */\r\n\r\n\r\n .videoCompOuterBox{\r\n    width: 100%;\r\n    height: 400px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 0;\r\n }\r\n.videoComp{\r\n    position: relative;\r\n    width: 100vw;\r\n    z-index: 1;\r\n    /* height: 300px; */\r\n}\r\n.videoBackgroundBox{\r\n    position: absolute;\r\n    background-color: rgba(0, 0, 0, 0.508);\r\n    color: #ffffff;\r\n    z-index: 2;\r\n    top: 200px;\r\n    height: 100%;\r\n    width: 100vw;\r\n    padding: 50px 0px 50px 100px;\r\n}\r\n.videoBackgroundText{\r\n    color: #ffffff;\r\n    width: 50vw;\r\n    \r\n}\r\n.titelUnderLine{\r\n    height: 3px;\r\n    width: 70px;\r\n    border-radius: 3px;\r\n    background-color:#077d92 ;\r\n    /* margin: 20px 0px; */\r\n}\r\n.ceoMainOutercontainer{\r\n    display: flex;\r\n    flex-direction: row;\r\n\r\n}\r\n.ceoMsgcontainer{\r\n    padding: 100px;\r\n    width: 50vw;\r\n\r\n}\r\n.ceoMsgFirsttxt{\r\n    color:  #097ea8 ;\r\n    letter-spacing: 2px;\r\n    font-weight: 200;\r\n}\r\n.aboutHeadertxt{\r\n    font-weight: 800;\r\n    color: #1d1d1d;\r\n}\r\n.ceoMsgBodytxt{\r\n    color: #1d1d1d;\r\n    padding-top: 20px; \r\n}\r\n.ceoAvaterContainer{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    padding-top: 30px; \r\n}\r\n.ceoMainContainerBg{\r\n    position: relative;\r\n    height: 500px;\r\n    width: 50vw;\r\n    background-image: url('../assets/images/product/DesignbackgroundAboutUs.png');\r\n}\r\n.AboutBodyImage{\r\n    margin-top: 15%;\r\n    width: 500px;\r\n}\r\n\r\n.aboutBodyContantOuter{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    padding: 100px;\r\n\r\n}\r\n.secondeContainerPaper{\r\n    padding: 50px;\r\n}\r\n.contentPaper{\r\n    margin: 40px;\r\n    box-shadow: none;\r\n}\r\n\r\n.nameTag1{\r\n    font-size: 24px;\r\n}\r\n.nameTag2{\r\n    font-size: 18px;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    \r\n    .secondeContainerPaper{\r\n        padding: 10px;\r\n    }\r\n    .AboutBodyImage{\r\n        height: 300px;\r\n        width: 300px;\r\n    }\r\n    .aboutBodyContantOuter{\r\n        padding: 10px 100px 10px 100px; \r\n    }\r\n    .ceoMsgcontainer{\r\n        padding: 30px 10px 30px 100px;\r\n    \r\n    }\r\n    .ceoMainContainerBg {\r\n        height: 300px;\r\n    }\r\n    .aboutHeadertxt{\r\n        font-size: 22px;\r\n    }\r\n    .ceoMsgBodytxt{\r\n        font-size: small;\r\n        padding-top: 0px;\r\n    }\r\n    .contentPaper{\r\n        margin: 10px;\r\n    }\r\n    .videoBackgroundText{\r\n        width: 70vw;\r\n    }\r\n}\r\n\r\n@media (max-width: 717px) {\r\n    \r\n    .AboutBodyImage{\r\n        height: 200px;\r\n        width: 200px;\r\n    }\r\n    .aboutBodyContantOuter{\r\n        padding: 10px 30px 10px 30px; \r\n    }\r\n    .ceoMsgcontainer{\r\n        width: 70vw;\r\n        padding: 20px 20px 20px 30px;\r\n    \r\n    }\r\n    .ceoMainContainerBg {\r\n        height: 250px;\r\n    }\r\n    .aboutHeadertxt{\r\n        font-size: 22px;\r\n    }\r\n   \r\n    .contentPaper{\r\n        margin: 10px;\r\n    }\r\n    .videoBackgroundText{\r\n        width: 70vw;\r\n        font-size: small;\r\n    }\r\n    .videoBackgroundBox{\r\n        padding: 10px 0px 10px 30px;\r\n    }\r\n    .ceoMsgFirsttxt{\r\n        font-size: smaller;\r\n    }\r\n    .aboutAvatar{\r\n        width: 48px;\r\n        height: 48px;\r\n        margin-right: 5px;\r\n    \r\n    }\r\n    .nameTag1{\r\n        font-size: 18px;\r\n    }\r\n    .nameTag2{\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n    \r\n    .videoCompOuterBox{\r\n\r\n        height: 200px;\r\n        \r\n     }\r\n     .videoBackgroundText{\r\n        font-size: x-small;\r\n        font-weight: 200;\r\n     }\r\n     .videoBackgroundBox{\r\n        top: 50px;\r\n        height: 100%;\r\n        width: 100vw;\r\n        padding: 20px 0px 20px 20px;\r\n    }\r\n   \r\n    .ceoMainContainerBg{\r\n        width: 10px;\r\n        height: 10px;\r\n    }\r\n    .ceoMsgcontainer{\r\n        padding: 20px;\r\n        width: 90vw;\r\n    \r\n    }\r\n\r\n    .ceoMsgFirsttxt{\r\n        font-size: x-small;\r\n    }\r\n    .aboutHeadertxt{\r\n        font-size: 18px;\r\n    }\r\n    .ceoMsgBodytxt{\r\n        font-size: x-small;\r\n    }\r\n    .aboutAvatar{\r\n        width: 32px;\r\n        height: 32px;\r\n    \r\n    }\r\n    .ceoAvaterContainer{\r\n        padding-top: 10px;\r\n    }\r\n    .nameTag1{\r\n        font-size: 11px !important;\r\n    }\r\n    .nameTag2{\r\n        font-size: 8px !important;\r\n    }\r\n    .aboutBodyContantOuter{\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-around;\r\n        padding: 20px;\r\n    \r\n    }\r\n}\r\n\r\n\r\n@media (max-width:1024px){\r\n    \r\n}\r\n@media (max-width:770px){\r\n    \r\n}\r\n@media (max-width:480px){\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoCompOuterBox": `aboutUs_videoCompOuterBox__Yk52H`,
	"videoComp": `aboutUs_videoComp__tcN+x`,
	"videoBackgroundBox": `aboutUs_videoBackgroundBox__ZkZ7L`,
	"videoBackgroundText": `aboutUs_videoBackgroundText__0B1dp`,
	"titelUnderLine": `aboutUs_titelUnderLine__JSrJD`,
	"ceoMainOutercontainer": `aboutUs_ceoMainOutercontainer__BFMqU`,
	"ceoMsgcontainer": `aboutUs_ceoMsgcontainer__iV-jx`,
	"ceoMsgFirsttxt": `aboutUs_ceoMsgFirsttxt__Uw6CI`,
	"aboutHeadertxt": `aboutUs_aboutHeadertxt__M1PN9`,
	"ceoMsgBodytxt": `aboutUs_ceoMsgBodytxt__cpM1z`,
	"ceoAvaterContainer": `aboutUs_ceoAvaterContainer__02vqu`,
	"ceoMainContainerBg": `aboutUs_ceoMainContainerBg__1Fh3U`,
	"AboutBodyImage": `aboutUs_AboutBodyImage__ccSp2`,
	"aboutBodyContantOuter": `aboutUs_aboutBodyContantOuter__vk9Y5`,
	"secondeContainerPaper": `aboutUs_secondeContainerPaper__vzOmo`,
	"contentPaper": `aboutUs_contentPaper__lzwVy`,
	"nameTag1": `aboutUs_nameTag1__O7Uzr`,
	"nameTag2": `aboutUs_nameTag2__LqcRn`,
	"aboutAvatar": `aboutUs_aboutAvatar__9qUc4`
};
export default ___CSS_LOADER_EXPORT___;
